if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        this.fetchAvailability(variant.id);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        this.innerHTML = sectionInnerHTML.innerHTML;

        this.querySelectorAll('pickup-availability-drawer').forEach((drawer) => {
          document.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') drawer.removeAttribute('open');
          });
        });
      }
    }
  );
}
if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector('.section-header');
        this.resizeObserver = new ResizeObserver(() => this.updatePosition());
        this.onClickOutside = this.onClickOutside.bind(this);
        this.clickOutsideTimeout = null;
        this.hasClickListener = false;
      }

      connectedCallback() {
        if (this.header) {
          this.resizeObserver.observe(this.header);
          this.updatePosition();
        }

        // Observe attribute changes to handle step expansion
        this.attributeObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
              if (this.hasAttribute('open')) {
                this.expandStep();
                // Add click-outside listener after a small delay to prevent immediate closure
                this.clickOutsideTimeout = setTimeout(() => {
                  if (this.hasAttribute('open') && !this.hasClickListener) {
                    document.addEventListener('click', this.onClickOutside);
                    this.hasClickListener = true;
                  }
                }, 100);
              } else {
                // Clear any pending timeout
                if (this.clickOutsideTimeout) {
                  clearTimeout(this.clickOutsideTimeout);
                  this.clickOutsideTimeout = null;
                }
                // Remove click-outside listener when drawer closes
                if (this.hasClickListener) {
                  document.removeEventListener('click', this.onClickOutside);
                  this.hasClickListener = false;
                }
              }
            }
          });
        });

        this.attributeObserver.observe(this, { attributes: true });
      }

      disconnectedCallback() {
        this.resizeObserver.disconnect();
        if (this.attributeObserver) {
          this.attributeObserver.disconnect();
        }
        if (this.clickOutsideTimeout) {
          clearTimeout(this.clickOutsideTimeout);
        }
        if (this.hasClickListener) {
          document.removeEventListener('click', this.onClickOutside);
          this.hasClickListener = false;
        }
      }

      onClickOutside(event) {
        // Close drawer if click is outside of it
        if (!this.contains(event.target)) {
          this.removeAttribute('open');
        }
      }

      expandStep() {
        const expandStep = this.getAttribute('data-expand-step');
        if (!expandStep) return;

        // Add a small delay so the drawer opens first, then the step expands
        setTimeout(() => {
          // First, collapse all timeline items
          const timelineItems = this.querySelectorAll('.timeline-item');
          timelineItems.forEach((item) => {
            item.removeAttribute('active');
          });

          let targetItem = null;

          if (expandStep === 'in-progress') {
            // Find the step marked as in-progress
            targetItem = this.querySelector('.timeline-item--in-progress');
          } else {
            // Find step by step number (5, 6, etc)
            const stepNumber = parseInt(expandStep, 10);
            if (!isNaN(stepNumber)) {
              // Detect if this is a Myo product by checking the number of timeline items
              // Myo products have 7 steps (0-6), non-Myo have 6 steps (1-6)
              const isMyo = timelineItems.length === 7;

              // Calculate the correct array index
              // If Myo: step 0 is at index 0, step 5 is at index 5, step 6 is at index 6
              // If not Myo: step 1 is at index 0, step 5 is at index 4, step 6 is at index 5
              const arrayIndex = isMyo ? stepNumber : stepNumber - 1;

              if (arrayIndex >= 0 && arrayIndex < timelineItems.length) {
                targetItem = timelineItems[arrayIndex];
              }
            }
          }

          // Expand the target step
          if (targetItem) {
            targetItem.setAttribute('active', '');

            // Scroll to the expanded step after a brief delay to allow expansion animation
            setTimeout(() => {
              targetItem.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }, 100);
          }

          // Clear the attribute after use
          this.removeAttribute('data-expand-step');
        }, 300);
      }

      updatePosition() {
        if (!this.header) return;
        const headerRect = this.header.getBoundingClientRect();
        const top = Math.max(0, headerRect.bottom);
        this.style.setProperty('top', `${top}px`);
        this.style.setProperty('height', `calc(100% - ${top}px)`);
      }
    }
  );
}
